GP.GPMod('StealthMode',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var _conf = {
        success_modal_timeout:  4000
    };

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;
        },
        page:  1,
        limit: 1,
        override_confirm: false,
        processing_stealth: false,
        stealth_expire_time: null,
        stealth_timer: null,
    };

    var gui = {
        init: function() {
            this.$btn_stealth_poke = $('#btn-stealth-poke');
            this.$btn_stealth_toggle = $('.btn-stealth-toggle');
            this.$timer = GP.Util.is_mobile() ? $('.stealth-timer-mobile') : $('.stealth-timer-desktop');
            this.$timer_mobile = $('.stealth-timer-mobile');
            this.$timer_desktop = $('.stealth-timer-desktop');
            this.$timer_paused_label = $('.stealth-timer-paused-label');
        },
        stealth_mode_on: function() {
            $(".nav-stealth").addClass('on').text('On');
            $(".nav-stealth-toggle").addClass('on');

            // turn on mobile sidebar stealth toggle
            gui.$btn_stealth_toggle
                .removeClass('stealth-paused')
                .addClass('stealth-on')
                .find('input').prop('checked', true);

            gui.$timer_paused_label.hide();
            handlers.show_expire_time();
        },
        stealth_mode_off: function() {
            $(".nav-stealth").removeClass('on').text('Off');
            $(".nav-stealth-toggle").removeClass('on');

            gui.$btn_stealth_toggle.find('input').prop('checked', false);
        },
        stealth_mode_paused: function() {
            gui.$btn_stealth_toggle.removeClass('stealth-on').addClass('stealth-paused');
            gui.$timer_paused_label.show();
            gui.$timer.hide();
        },
    };

    var apis = {
        add_stealth_mode: function() {
            $('.modal .error_container').hide();
            $('#btn-stealth-poke span').show();

            var stealth_mode_level = 2;
            var stealth_mode_hours = $("input[type='radio'][name=stealth_mode_hours]:checked", '#stealth-mode-form').val();

            if (!_data.processing_stealth) {
                _data.processing_stealth = true;

                $.post('/members/user/stealth_mode', {
                    'process' : 1,
                    'ice_breaker_msg': $('.select-stealth').val(),
                    'stealth_level' : stealth_mode_level,
                    'stealth_hours' : stealth_mode_hours
                })
                .done(function(json) {
                    if (json && json.success) {
                        handlers.stealth_success(json);
                        vent.trigger('Modal:close', _conf.success_modal_timeout);
                    } else {
                        handlers.stealth_error(json);
                    }
                })
                .fail(function() {
                    handlers.stealth_error();
                })
                .always(function() {
                    _data.processing_stealth = false;
                    $('#btn-stealth-poke span').hide();
                });
            }
        },
        pause_stealth_mode: function() {
            if (!_data.processing_stealth) {
                _data.processing_stealth = true;

                $.post('/members/user/stealth_mode', {
                    'pause' : 1
                })
                .done(function(json) {
                    if (json && json.success) {
                        handlers.stealth_paused(json);
                    } else {
                        handlers.stealth_error(json);
                    }
                })
                .fail(function() {
                    handlers.stealth_error();
                })
                .always(function() {
                    _data.processing_stealth = false;
                });
            }
        },
        resume_stealth_mode: function() {
            if (!_data.processing_stealth) {
                _data.processing_stealth = true;

                $.post('/members/user/stealth_mode', {
                    'resume' : 1
                })
                .done(function(json) {
                    if (json && json.success) {
                        handlers.stealth_resumed(json);
                    } else {
                        handlers.stealth_error(json);
                    }
                })
                .fail(function() {
                    handlers.stealth_error();
                })
                .always(function() {
                    _data.processing_stealth = false;
                });
            }
        }
    };

    var handlers = {
        stealth_success: function(json) {
            var $success_container = $('.modal .success_container');
            $success_container.show();

            // update with expire time from api
            if (json && json.expire_time) {
                _data.stealth_expire_time = json.expire_time;
            }

            if (json) {
                handlers.update_stealth_status(json);
            }

            gui.stealth_mode_on();

            setTimeout(function() {
                $success_container.hide();
            }, 3000);
        },
        stealth_paused: function(json) {
            if (json) {
                handlers.update_stealth_status(json);
            }

            gui.stealth_mode_paused();
            handlers.clear_timer();
        },
        stealth_resumed: function(json) {
            // update with expire time from api
            if (json && json.expire_time) {
                _data.stealth_expire_time = json.expire_time;
            }

            if (json) {
                handlers.update_stealth_status(json);
            }

            gui.stealth_mode_on();
        },
        stealth_error: function(json) {
            var error_message = 'Stealth Mode error occured';

            if (json && json.error) {
                error_message = json.error;
            } else if (typeof _stealth_mode_default_error != 'undefined' && _stealth_mode_default_error) {
                error_message = _stealth_mode_default_error;
            }

            var $error_container = $('.modal .error_container');
            $error_container.find('p').remove();

            $error_container.append('<p class="error">'+error_message+'</p>');
            $error_container.show();
            events.cancel_stealth_mode();

            if (json && json.low_credits) {
                setTimeout(function() {
                    vent.trigger('Modal:close');
                    vent.trigger('Modal:open', {url: '/members/billing/add_credits/?hide_earn_credits=1'});
                }, 3000);
            }
        },
        show_expire_time: function() {
            if (_data.stealth_expire_time !== null) {
                gui.$timer.show();
                this.update_timer();

                if (!_data.stealth_timer) {
                    _data.stealth_timer = setInterval(handlers.update_timer, 1000);
                }
            }
        },
        get_remaining_time: function() {
            const current_time = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
            const total = Date.parse(_data.stealth_expire_time) - Date.parse(current_time);
            const seconds = Math.floor((total / 1000) % 60);
            const minutes = Math.floor((total / 1000 / 60) % 60);
            const hours = Math.floor((total / (1000 * 60 * 60)) % 24);

            return {
                total,
                hours,
                minutes,
                seconds
            };
        },
        update_timer: function() {
            let time = handlers.get_remaining_time();

            let hours_wrap = gui.$timer.find('.hours');
            let minutes_wrap = gui.$timer.find('.minutes');
            let seconds_wrap = gui.$timer.find('.seconds');

            if (time.total <= 0) {
                gui.$timer.hide();
                events.cancel_stealth_mode();
                handlers.clear_timer();

                return;
            }

            hours_wrap.html(('0' + time.hours).slice(-2));
            minutes_wrap.html(('0' + time.minutes).slice(-2));
            seconds_wrap.html(('0' + time.seconds).slice(-2));
        },
        clear_timer: function() {
            clearInterval(_data.stealth_timer);
            _data.stealth_timer = null;
        },
        update_stealth_status: function(json) {
            if (json && json.expire_time) {
                GP.sdata.my_user.stealth_mode = true;
            }
            if (json && json.stealth_paused) {
                GP.sdata.my_user.stealth_paused = json.stealth_paused;
            }
        },
    };

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_modal",          events.setup_modal);
            vent.on(self.moduleName+":show_stealth_mode",    events.show_stealth_mode);
            vent.on(self.moduleName+":cancel_stealth_mode",  events.cancel_stealth_mode);
            vent.on(self.moduleName+":stealth_success",      handlers.stealth_success);
            vent.on(self.moduleName+":stealth_mode_paused",  gui.stealth_mode_paused);
            vent.on(self.moduleName+":pause_stealth_mode",   apis.pause_stealth_mode);
            vent.on(self.moduleName+":resume_stealth_mode",  apis.resume_stealth_mode);
            gui.$btn_stealth_toggle.on('change', events.btn_stealth_toggle);
        },
        setup_modal: function() {
            gui.init();

            // setup the bind for the submit button
            $('#btn-stealth-poke').on('click', function(e) {
                e.preventDefault();
                apis.add_stealth_mode();
            });
            $('.stealth-credit-1').on('click', function(e) {
                $(this).removeClass('stealth-credit-unselected').addClass('stealth-credit-selected');
                $('.stealth-credit-3').removeClass('stealth-credit-selected').addClass('stealth-credit-unselected');
            });
            $('.stealth-credit-3').on('click', function(e) {
                $(this).removeClass('stealth-credit-unselected').addClass('stealth-credit-selected');
                $('.stealth-credit-1').removeClass('stealth-credit-selected').addClass('stealth-credit-unselected');
            });
        },
        show_stealth_mode: function() {
            // set to expire time from get_js_user_obj.php
            if (typeof GP.sdata.my_user.stealth_expire_time != 'undefined' && GP.sdata.my_user.stealth_expire_time) {
                _data.stealth_expire_time = GP.sdata.my_user.stealth_expire_time;
            }

            gui.stealth_mode_on();
        },
        btn_stealth_toggle: function(e) {
            if ($(this).find('input').is(':checked') && !$(this).hasClass('stealth-paused')) {
                vent.trigger('Modal:open', {url: '/members/user/stealth_mode/'});
            } else {
                // if toggle was already checked then we are either pausing or resumimg stealth mode
                if ($(this).hasClass('stealth-paused')) {
                    apis.resume_stealth_mode();
                } else if ($(this).hasClass('stealth-on')) {
                    apis.pause_stealth_mode();
                }
            }
        },
        cancel_stealth_mode: function() {
            gui.$btn_stealth_toggle.find('input').prop('checked', false);
        }
    };

    this.addInitializer(function(){
        _data.init();
        gui.init();
        events.init();
    });
});
